<template>
  <IonPage>
    <AppHeader></AppHeader>
    <IonContent :scroll-y="false">
      <IonRouterOutlet :key="$route.matched.length" id="main-content"></IonRouterOutlet>
    </IonContent>
    <Teleport to="#app">
      <AppMenu></AppMenu>
    </Teleport>
  </IonPage>
</template>

<script setup lang="ts">
import AppHeader from '@/components/menu/AppHeader.vue';
import AppMenu from '@/components/menu/AppMenu.vue';
import { IonContent, IonPage, IonRouterOutlet } from '@ionic/vue';
</script>

<style scoped></style>
